<template>
  <div class="popUpWrap">
    <section class="popup dark assessment">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="icon agree"></div>
        <div class="textArea flex">
          <h5>{{ t('skillCertify-sample-information-title') }}</h5>
        </div>
        <div class="boxArea">
          <ul class="listDot">
            <li>{{ t('skillCertify-sample-information-new-description-4') }}</li>
            <li>{{ t('skillCertify-sample-information-new-description-1') }}</li>
            <li>{{ t('skillCertify-sample-information-new-description-3') }}</li>
            <li v-if="dialogStore.options.props?.isBasicProctoring" class="blue">{{ t('skillCertify-sample-information-new-description-2') }}</li>
          </ul>
        </div>
        <div class="btnArea">
          <button type="button" @click.stop="onClickOk">{{ t('common-ok') }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useI18n} from '#imports';

const { t } = useI18n();

const dialogStore = useDialogStore();

const onClickClose = () => {
  dialogStore.close()
}

// 닫기를 먼저 한다 (GenericAlertPopup 과 같은 순서). 콜백이 다음 팝업을 여는 경우가 있는데,
// 이전 순서(event → close)는 방금 열린 팝업까지 show=false 로 덮어 버렸다 —
// BR-1757 로 샘플 진입 전에 화면 공유 점검 안내를 띄우면서 드러났다.
// dialogStore.close() 는 show 만 내리고 options 는 그대로 두므로 이 순서가 안전하다.
const onClickOk = () => {
  dialogStore.close()
  dialogStore.options.close?.event()
}
</script>
